import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface CancelInvoiceRequest {
  invoiceIds?: number[];
}

const useCancelInvoicesApi = () => {
  const call = useCallback(async ({ invoiceIds }: CancelInvoiceRequest = {}) => {
    try {
      const res = await axiosInstance.post(api.cancelInvoice, invoiceIds);
      return res;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { isLoading, execute } = useAsync(call, false);

  return { cancelInvoices: execute, cancelInvoicesLoading: isLoading };
};

export default useCancelInvoicesApi;
